import * as React from 'react';
import { SVGProps } from 'react';

const IconSmileStrokedSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12 10H9v3h3v-3ZM16 10h3v3h-3v-3ZM7.728 16.795c2.897 4.635 9.647 4.635 12.544 0l-2.544-1.59c-1.722 2.755-5.734 2.755-7.456 0l-2.544 1.59Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26 14c0 6.627-5.373 12-12 12S2 20.627 2 14 7.373 2 14 2s12 5.373 12 12Zm-3 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    />
  </svg>
);
export default IconSmileStrokedSizeL;
